interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "CLP";
};

const CLP: Currency = Object.freeze({
  "displayName": "Chilean Peso",
  "numericCode": 152,
  "defaultFractionDigits": 0,
  "subUnit": 1,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "CLP",
  "symbol": "$"
});

export { CLP };
